import { takeEvery, put, call, select, take } from 'redux-saga/effects';
import callApi from 'utils/api';
import { getUrlParameters } from 'utils/helpers';
import * as actionTypes from './constants';

import { getReferenceDataSuccess, getReferenceDataFailure } from './reference-data-actions';
import { NAVIGATION_DETAILS_SUCCESS } from '../../navigation/containers/constants';

export const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;

export function* fetchReferenceData(action) {
  try {
    let { serviceCenterId } = action.payload;

    if (!serviceCenterId) {
      const navigationalServiceCenterId = yield select(getServiceCenterId);
      if (!navigationalServiceCenterId) {
        yield take(NAVIGATION_DETAILS_SUCCESS);
        serviceCenterId = yield select(getServiceCenterId);
      } else {
        serviceCenterId = navigationalServiceCenterId;
      }
    }

    const { payload } = action;

    const endpoint =
      payload.endpoint ||
      `refdata/lists/${serviceCenterId}/${payload.objectType}/${payload.name}?${getUrlParameters({
        params: payload.urlParams,
      })}`;

    const results = yield call(callApi, {
      endpoint,
      options: {
        errorMessage: `Could not get reference data for ${payload.name}`,
        retryAction: action,
      },
    });

    yield put(
      getReferenceDataSuccess({
        results,
        objectType: payload.objectType,
        name: payload.name,
        hasSubTypes: payload.hasSubTypes,
        valueProperty: payload.valueProperty,
        serviceCenterId,
      }),
    );
  } catch (err) {
    yield put(
      getReferenceDataFailure({
        ...err,
        objectType: action.payload.objectType,
        name: action.payload.name,
        serviceCenterId: action.payload,
      }),
    );
  }
}

export default function* watchGetReferenceData() {
  yield takeEvery(actionTypes.GET_REFERENCE_DATA_REQUEST, fetchReferenceData);
}
